export const disabledProps = {
  bg: "gray.100",
  borderColor: "gray.300",
  borderWidth: "1px",
  color: "gray.500",
  opacity: 1,
  pointerEvents: "auto",
};
